import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { reportsApi } from '../services/reports-settings';
import { FintracSettings } from '../../reports/fintrac/types';

export interface ReportsSettingsState {
  fintracReportSettings?: FintracSettings;
}

const initialState: ReportsSettingsState = {};

export const reportsSettingsSlice = createSlice({
  name: 'reportsSettings',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addMatcher(
      reportsApi.endpoints.getFintracSettings.matchFulfilled,
      (state, action: PayloadAction<{ data: FintracSettings }>) => {
        state.fintracReportSettings = action.payload.data;
      },
    );
    builder.addMatcher(
      reportsApi.endpoints.updateFintracReportSettings.matchFulfilled,
      (state, action: PayloadAction<{ data: FintracSettings }>) => {
        state.fintracReportSettings = action.payload.data;
      },
    );
  },
});

export default reportsSettingsSlice.reducer;
